import { Consumables } from "ckeditor5";

export interface IState {
  consumables: Consumables[];
  consumablesCount: number;
}

type Action = any;

export const consumablesReducer = (
  state: IState = {
    consumables: [],
    consumablesCount: 0,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_CONSUMABLES":
      return {
        ...state,
        consumables:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.consumables, ...action?.payload?.data],
        consumablesCount: action?.payload?.count,
      };
    case "UPDATE_CONSUMABLES":
      return {
        ...state,
        consumables: state?.consumables?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_CONSUMABLES":
      return {
        ...state,
        consumables: state?.consumables?.filter((elem: any) => elem?._id !== action?.payload),
      };
    default:
      return state;
  }
};
